import DocumentToValidateDetailPage from '@/pages/requests/detailPages/supplierDetailPages/DocumentToValidateDetailPage.vue'
import InvoiceCreateForm from '@/pages/requests/creationPages/InvoiceCreateTemplate.vue'
import ListSellersFromApplicationForm from '@/pages/LMSGiframe/ListSellersFromApplicationForm.vue'
import PaymentFromApplicationForm from '@/pages/LMSGiframe/PaymentFromApplicationForm.vue'
import PaymentFromApplicationTestForm from '@/pages/LMSGiframe/PaymentFromApplicationTestForm.vue'
import ProjectCreateForm from '@/pages/requests/creationPages/ProjectCreateTemplate.vue'
import SupplierCreateForm from '@/pages/requests/creationPages/SupplierCreateTemplate.vue'
import SuppliersDetailPage from '@/pages/requests/detailPages/supplierDetailPages/SupplierDetailPage.vue'
import SuppliersDocForm from '@/pages/requests/detailPages/supplierDetailPages/SupplierDocForm.vue'
import SuppliersKYCForm from '@/pages/requests/detailPages/supplierDetailPages/SupplierKYCForm.vue'
import SupplierEditPage from '@/pages/requests/editPages/SupplierEditTemplate.vue'
import SendDocumentsFromApplicationForm from '@/pages/LMSGiframe/SendDocumentsFromApplicationForm.vue'

export default [
  {
    path: '/suppliers/documentsToValidateDetails',
    alias: [],
    component: DocumentToValidateDetailPage
  },
  {
    path: '/invoices/create',
    alias: [],
    component: InvoiceCreateForm
  },
  {
    path: '/projects/create',
    alias: [],
    component: ProjectCreateForm
  },
  {
    path: '/suppliers/create',
    alias: [],
    component: SupplierCreateForm
  },
  {
    path: '/suppliers/details',
    alias: [],
    component: SuppliersDetailPage
  },
  {
    path: '/suppliers/docform',
    alias: [],
    component: SuppliersDocForm
  },
  {
    path: '/suppliers/kycform',
    alias: [],
    component: SuppliersKYCForm
  },
  {
    path: '/suppliers/edit',
    alias: [],
    component: SupplierEditPage
  },
  {
    path: '/kycform/',
    component: SuppliersKYCForm
  },
  {
    path: '/sendDocumentsFromApplication/',
    component: SendDocumentsFromApplicationForm
  },
  {
    path: '/listSellersFromApplication/',
    component: ListSellersFromApplicationForm
  },
  {
    path: '/paymentFromApplication/',
    component: PaymentFromApplicationForm
  },
  {
    path: '/paymentFromApplicationTest/',
    component: PaymentFromApplicationTestForm
  }
]



// WEBPACK FOOTER //
// ./src/routes/services/suppliers.js